export default "__VITE_ASSET__e75c91a4__"